<template>
    <div class="timeline" :class="{ 'mobile': $mobile }">
        <div class='border'></div>
        <div class='episode-list'>
        	<v-touch tag="ul" class="copy-01 episodes" v-on:swipeleft="slideRight" v-on:swiperight="slideLeft">
        		<li class="episode" :style="{ width: width() }" v-for="(episode, index) in episodes" :class="{ 'locked': episode.locked, 'active': index === $store.state.game.episode || $store.state.debugmode, 'complete': $store.state.game.episodes[index].answers.length === $store.state.game.episodes[index].actions.length }"  @click="startEpisode(index)" >
        			<h4>{{ episode.title }}</h4>
                    <div class='thumbnail-container' :class="{ 'mobile': $mobile }">
                        <img class="thumbnail" :src="episode.thumbnail"/>
                        <div class='state'></div>
                    </div>
        		</li>
        	</v-touch>
            <div class='arrows' v-if="!$mobile">
                <div :class="{'hidden': activeEp == 0}" class='arrow-left nav-arrow' @click="slideLeft()"></div>
                <div :class="{'hidden': activeEp == episodes.length -1}"class='arrow-right nav-arrow' @click="slideRight()"></div>
            </div>
            <ul class="pagination">
                <li class="pagination-bullet" v-for="(episode, index) in episodes" :class="{ 'locked': episode.locked, 'active': index === $store.state.game.episode, 'complete': $store.state.game.episodes[index].answers.length === $store.state.game.episodes[index].actions.length, 'mobile': $mobile }" >
                </li>
            </ul>
        </div>
        <div class="points-container" v-if="!$mobile">
            <span> Totaal aantal punten: </span>{{ points }}
        </div>
    </div>
</template>

<script>
    import './Timeline.scss'
    import { episodes } from '../data'

    export default {
        name: 'Timeline',
        data () {
            return {
                episodes,
                episodeWidth:(($(window).innerWidth() / 3) - 80),
                activeEp: 0
            }

        },
        mounted () {

            TweenLite.to ('.main-bg-image', 0.5, {opacity:1});

            var that = this;
            $(window).resize(function(){
                $( ".episode" ).each(function( index, element ) {
                    if ($(element).hasClass ("active")){
                        that.slide()
                        return false;
                    }
                })
                that.episodeWidth = (($(window).innerWidth() / 3) - 80)
                that.width();
            })
            var lastComplete = $('.complete .thumbnail-container').slice(-1)[0]
            $(lastComplete).append( '<div class="active-state"></div>' )
            $( '.active .thumbnail-container' ).append( '<div class="locked-state"></div>' )
            TweenLite.set($(lastComplete).find('.state'), {opacity:0, scale:0})
            TweenLite.set('.active .state', {x:'-50%', y:'-50%', opacity:0, scale:0})
            
            var epnr = 0;
            $( ".episode" ).each(function( index, element ) {
                if ($(element).hasClass ("active")){
                    TweenLite.set(".episodes", {x: - (index - 2) * $(window).innerWidth() / 3})
                    that.activeEp = index

                    
                    TweenLite.to('.active-state', 0.5, {opacity:0, delay:0.5})
                    TweenLite.to('.complete .state', 0.5, {opacity:1, delay:0.6, scale:1,ease: Back.easeOut.config(1.7), onComplete: ()=> {
                        $('.active-state').remove();
                        that.slide()

                        TweenLite.to('.locked-state', 0.5, {opacity:0, delay:1})
                        TweenLite.to('.active', 1, {scale:1.3});
                        TweenLite.to('.active .state', 0.5, {opacity:1, delay:1.3, scale:1,ease: Back.easeOut.config(1.7), onComplete: ()=> {
                            $('.locked-state').remove();
                        }})
                    }})
                    
                    return false;
                } else if ($(element).not ("active") && $(element).not ("complete") ){
                    $(element).addClass('complete');
                    $($('.pagination-bullet')[epnr]).addClass('complete');
                }
                epnr ++
            })

            if ($(".episode").length == $(".complete").length / 2 ){
                this.$router.push('/uitspraak')
            } else {
                if ($( ".active" ).hasClass('complete') || $( ".active" ).hasClass('locked') || $( ".complete" ).hasClass('locked')){
                    $( ".active" ).removeClass('locked')
                    $( ".active" ).removeClass('complete')
                    $( ".complete" ).removeClass('locked')
                }
            }

            $( ".active" ).hover(
              function() {
                TweenLite.to ($(this).find(".state"), 0.3, {backgroundPositionX: '200%', ease: Power1.easeOut});
                TweenLite.set ($(this).find(".state"), {backgroundPositionX: '-200%', delay:0.3});
                TweenLite.to ($(this).find(".state"), 0.3, {backgroundPositionX: '60%', ease: Power1.easeOut, delay:0.3});
              }, function() {

              }
            );
        },
        methods: {
            startEpisode (episode) {
                if (episode === this.$store.state.game.episode) {
                    this.$router.push('/')
                } else if (this.$store.state.debugmode) {
                    this.$store.dispatch('CHANGE_EPISODE', {episode: episode})
                    this.$router.push('/')
                }
            },
            width () {
                return this.episodeWidth + 'px'
            },
            slideLeft () {
                if (this.activeEp > 0){
                    this.activeEp --
                    this.slide();
                }
            },
            slideRight () {
                if (this.activeEp < $(".episode").length -1){
                    this.activeEp ++
                    this.slide();
                }
            },
            slide() {


                var slidePos = 0

                if (this.activeEp === 0){
                    slidePos = ($(window).innerWidth() / 3)
                } else {
                    slidePos = (-($(window).innerWidth() / 3) * this.activeEp) + ($(window).innerWidth() / 3)
                }

                TweenLite.to (".episodes", 1, {delay:0.1, x: slidePos});

                this.updatePagination();
            },
            updatePagination() {
                var paginationActive = $('.pagination-bullet')[this.activeEp];
                var episodeActive = $('.episode')[this.activeEp];
                $('.pagination-bullet').removeClass('highlighted')
                $(paginationActive).addClass('highlighted');
                TweenLite.to('.episode', 1, {scale:1.2});
                TweenLite.to(episodeActive, 1, {scale:1.4});
            }
        },
        computed: {
            points: {
                get () {
                    let points = 0
                    for (let i in this.$store.state.game.episodes) {
                        let episode = this.$store.state.game.episodes[i]
                        points += episode.points
                    }
                    return points
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Timeline.vue?6b92252a